/**
 * Amount the customer still has to pay on an invoice.
 *
 * Prefers `balance_due` when the backend provides it (it accounts for
 * partial payments); falls back to `total_amount`. Never returns a
 * negative or non-finite number.
 */
export const resolveAmountDue = (invoice = {}) => {
  const balance = Number(invoice?.balance_due);
  const total = Number(invoice?.total_amount);

  if (invoice?.balance_due != null && Number.isFinite(balance)) {
    return Math.max(0, balance);
  }
  if (Number.isFinite(total)) {
    return Math.max(0, total);
  }
  return 0;
};
